/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateReportOptionDto
 */
export interface CreateOrUpdateReportOptionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateReportOptionDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateReportOptionDto
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateReportOptionDto
     */
    $type?: CreateOrUpdateReportOptionDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateReportOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedReportComponentDtoCreateOrUpdateReportOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.ReportComponent.Dto.CreateOrUpdateReportOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateReportOptionDtoTypeEnum = typeof CreateOrUpdateReportOptionDtoTypeEnum[keyof typeof CreateOrUpdateReportOptionDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateReportOptionDto interface.
 */
export function instanceOfCreateOrUpdateReportOptionDto(value?: unknown): value is CreateOrUpdateReportOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateReportOptionDtoTypeEnum)[0];
}

export function CreateOrUpdateReportOptionDtoFromJSON(json: any): CreateOrUpdateReportOptionDto {
    return CreateOrUpdateReportOptionDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateReportOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateReportOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateReportOptionDtoToJSON(value?: CreateOrUpdateReportOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'address': value.address,
        'imageId': value.imageId,
        '$type': value.$type,
    });
}

